import moment from "moment";

export const formatDateYear = (date?: Date | string | null) => {
  if (!date) return "";
  const parsed = date instanceof Date ? date : new Date(date);
  if (isNaN(parsed.getTime())) return "";
  return moment(parsed).format("YYYY");
};
